<mtg-button
  color="secondary"
  class="download-btn"
  [mtgDropdownTriggerFor]="files"
>
  Документы
</mtg-button>
<mtg-dropdown-menu #files>
  <mtg-dropdown-item (click)="printApplication('tournament_user')">Составы команд</mtg-dropdown-item>
  <mtg-dropdown-item (click)="printApplication('game_user')">Заявка на игру</mtg-dropdown-item>
  <mtg-dropdown-item (click)="printProtocol()">Протокол (печать)</mtg-dropdown-item>
  <mtg-dropdown-item (click)="downloadGameProtocol()">Протокол игры</mtg-dropdown-item>
</mtg-dropdown-menu>
